/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { ProjectPreviewFragmentDoc } from "../../projects/graphql/fragments.generated"
import { UserFragmentDoc } from "../../team-members/graphql/fragments.generated"
import { TeamPreviewFragmentDoc } from "../../teams/graphql/fragment.generated"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type TeamInvitationFragment = {
  __typename: "TeamInvitation"
  id: string
  role: string
  invitationAcceptedAt?: string | null
  invitationAccepted: boolean
  invitationRejected?: boolean | null
  acceptInvitationPath: string
  team: {
    __typename: "Team"
    id: string
    name: string
    description?: string | null
    projects?: Array<{
      __typename: "Project"
      id: string
      title: string
      phase?: {
        __typename: "ProjectPhase"
        id: string
        value: string
        label: string
      } | null
    }> | null
  }
  user?: {
    __typename: "User"
    id: string
    name?: string | null
    email: string
    createdAt: string
    updatedAt: string
  } | null
  invitedBy?: {
    __typename: "User"
    id: string
    name?: string | null
    email: string
    createdAt: string
    updatedAt: string
  } | null
}

export const TeamInvitationFragmentDoc = gql`
  fragment TeamInvitation on TeamInvitation {
    id
    role
    invitationAcceptedAt
    invitationAccepted
    invitationRejected
    acceptInvitationPath
    team @type(name: "Team") {
      ...TeamPreview
      projects @type(name: "Project") {
        ...ProjectPreview
      }
    }
    user @type(name: "User") {
      ...User
    }
    invitedBy @type(name: "User") {
      ...User
    }
  }
  ${TeamPreviewFragmentDoc}
  ${ProjectPreviewFragmentDoc}
  ${UserFragmentDoc}
`
